<template>
  <div class="m-6 is-justify-content-center is-align-items-start is-flex">
    <div>
      <div class="card">
        <div class="rtl card-content">
          <p>מספר משרות ייעודיות:</p>
          <ul>
            <li v-for="{admin, alerts} of alertsCounters" :key="admin">
              {{ admin }}: {{ alerts }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="is-justify-content-center is-align-items-center is-flex">
      <h2 class="m-6">Select number of positions:</h2>
      <BaseInput v-model="positionsNumber" />
      <button class="button is-info m-6" @click="onSubmit">Submit</button>
    </div>
  </div>
</template>
<script>
// imports
import BaseInput from '@/components/BaseInput'

export default {
  name: 'AdminDesignatedPosition',
  components: {
    BaseInput
  },
  data () {
    return {
      positionsNumber: null,
      alertsCounters: []
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    async onLoad () {
      try {
        this.alertsCounters = await this.$network_utils.getCounters({
          designated_positions: 'true'
        })
      } catch (e) {
        console.log(e)
      }
    },
    async onSubmit () {
      try {
        await this.$network_utils.postEvent({
          event: 'create_designated_positions',
          positions_number: this.positionsNumber,
          current_type: 'Admin',
          current_resource_id: this.$utils.getOwner().id
        })
        this.$utils.emit('show_toast', { text: 'success' })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
